import { Register } from 'digicon-web-login/register';

export default class OverrideRegister extends Register {

    constructor(props) {
        super(props);
        this.props = props;
    }

    _attempRegister() {
        // Do something before register
        const formError = this._form.checkFormError();
        if (formError) {
            document.getElementById('loginUI_register_error').innerHTML = formError;
            return;
        }

        const typeFloor = this._form.fields.filter(e => e.id == "TipoFloor")[0];
        const typeFloat = this._form.fields.filter(e => e.id == "TipoFloat")[0];
        if ((typeof (typeFloor.fobj.field.value) == 'undefined' || typeFloor.fobj.field.value == false) && (typeof (typeFloat.fobj.field.value) == 'undefined' || typeFloat.fobj.field.value == false)) {
            document.getElementById('loginUI_register_error').innerHTML = "formsTypeNotSelectedError";
            return;
        }

        document.getElementById('loginUI_register_error').innerHTML = '';
        super._attempRegister();
    }
}